import { Typography } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";

export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;

export const StyledContainer = styled(Container)`
  @media (max-width: 900px) {
    padding: 0 !important;
  }
`;

// export const StyledCard = styled(Card)`
//   background-color: ${theme.palette.primary.light} !important;
//   width: 100%;
//   margin-bottom: 10px;
//   position: relative;
// `;
export const StyledCard = styled(Card)`
  background-color: transparent !important;
  width: 100%;
  margin-bottom: 10px;
  position: relative;
  border-radius: 0 !important;
  box-shadow: none !important;
  border-bottom: 2px solid #0000002b;
  // :first-child {
  //   border-top: 2px solid #0000002b;
  //   padding-top: 10px;
  // }
`;

export const StyledTypography = styled(Typography)`
  height: 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -moz-box-orient: vertical;
  line-height: 27px !important;
`;

export const StyledNewMessage = styled.div`
  padding: 4px;
  background: ${theme.palette.primary.dark};
  display: inline-block;
  position: absolute;
  top: 5px;
  left: 5px;
  color: white;
  border-radius: 4px;
  font-size: 9px;
`;

export const StyledCardActions = styled(CardActions)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px !important;
  padding-top: 0 !important;
  padding-left: 0 !important;
  & > p {
    margin: 0;
  }
`;
